import { HttpParams } from '@angular/common/http';
import { Component, OnInit, Renderer2, RendererFactory2, ViewChild, ViewContainerRef } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, StatusPanelDef, GridReadyEvent, GridOptions, RowSelectedEvent, ISelectCellEditorParams } from 'ag-grid-community';
import { ConfirmationService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from 'src/app/services/api.service';
import { CustomMessageService } from 'src/app/services/custom.message.service';
import { SearchGeAssessmentsHeader } from 'src/app/shared/searchGeAssessmentsHeader';
import { StaticFields } from 'src/app/shared/staticFields';

@Component({
  selector: 'app-geassessmentmodal',
  templateUrl: './geassessmentmodal.component.html',
  styleUrl: './geassessmentmodal.component.scss'
})
export class GeassessmentmodalComponent implements OnInit {
  crops: any[] = [];
  selectedCrop : any;
  disableCrop : boolean = true;
  assessmentMembersList: any[]= [];
  assessmentMembers: any[] = [];
  searchType: string = "Get All Assessments";
  searchBy: string = "By Name";
  selectType: string = "Show all Assessments";
  showSelected : boolean = false
  selectedMembers: any;
  enableSearch : boolean = false;
  rowData : any[] =[];
  idList: string[] = [];
  selTraits: any = [];
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    minWidth : 50, 
    resizable: true
  };
  public columnDefs: any[] = [
    { field: '', pinned: 'left', checkboxSelection: true, headerCheckboxSelection : true, headerCheckboxSelectionFilteredOnly: true, suppressFiltersToolPanel: true, lockPosition: "left", suppressHeaderFilterButton: true,suppressHeaderMenuButton: true,resizable: false, width:15,
      tooltipValueGetter: (params: any) => {
        if (this.session && StaticFields.precodeScreenData?.selectedAssessmentsList && StaticFields.precodeScreenData.selectedAssessmentsList.findIndex((s: any) => s.traitId === params.data.traitId) > -1)
          return `Part of ${this.session} session, can't be unselected.`;
        return null;
      }
    },
    { field: 'traitName', headerName : 'Assessment Name', filter: 'agTextColumnFilter', filterParams: { buttons: ["clear"] },width : 165 },
    { field: 'source', headerName : 'Source', width : 110, cellEditor: "agSelectCellEditor", editable: this.allowEdit.bind(this),
      cellEditorParams: {
        values: ["Precode", "Parent", "Both"],
      } as ISelectCellEditorParams, 
    },
    { field: 'vvsType', headerName : 'VVS Type', width : 120 },
    { field: 'description', headerName : 'Assessment Description', filter: 'agTextColumnFilter', filterParams: { buttons: ["clear"] }, flex : 1 },
    { field: 'traitId', headerName : 'Assessment Id', filter: 'agTextColumnFilter', filterParams: { buttons: ["clear"] }, width : 165 }
  ];
  public statusBar: {
    statusPanels: StatusPanelDef[];
  } = {
    statusPanels: [
      { statusPanel: 'agTotalRowCountComponent', align: 'left' },
      { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left',  },
      { statusPanel: 'agFilteredRowCountComponent', align : 'left' },
      { statusPanel: 'agSelectedRowCountComponent', align : 'left' },
     
    ],
  };
  gridOptions : GridOptions = {
    context: {
      componentParent: this,
    },
    singleClickEdit: true,
    isRowSelectable: (node) => { 
      if (this.session && StaticFields.precodeScreenData?.selectedAssessmentsList && StaticFields.precodeScreenData.selectedAssessmentsList.findIndex((s: any) => s.traitId === node.data.traitId) > -1)
        return false;
      return true; 
    }
  }
  gridApi: any;
  selectedType: string;
  allGETraits: any;
  renderer: Renderer2;
  preSelectedAssessments: any[] = [];
  onlyActiveTraits: boolean = true;
  session: string;

  constructor(private apiService : ApiService,public config : DynamicDialogConfig, public ref : DynamicDialogRef,public customMessageService: CustomMessageService,
    private confirmationService : ConfirmationService,private readonly rendererFactory: RendererFactory2,
    private viewContainerRef: ViewContainerRef
  ) {
    this.renderer = rendererFactory.createRenderer(null,null);
    this.selectedType = 'Show all Assessments';
  }

  get selectedAssessments() : number {
    return this.gridApi && !this.gridApi.isDestroyed() && this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows().length : 0;
  }

  get idListText(): string {
    return this.idList.join("\r\n");
  }

  set idListText(value) {
    this.idList = value.split(/\r?\n/);
    if (this.idList.length < 2)
      this.idList = value.split(",");
    this.idList = this.idList.filter((v, i, a) => a.indexOf(v) === i);
    this.idList = this.idList.map(s => s.trim()).filter(s => s);
    // let invalidId = "";
    // for (let i = 0; i < this.idList.length; i++) {
    //   if (!this.validateNumber(this.idList[i])) {
    //     invalidId = this.idList[i];
    //     break;
    //   }
    // }
    // if (invalidId) {
    //   this.customMessageService.showMessage({severity:'warn', summary : 'Invalid Id', detail: invalidId + " is not a number. Please enter valid values."});
    //   this.idList.splice(0);
    // }
  }

  ngOnInit(): void {
    this.crops = this.config.data.crops;
    this.selectedCrop = this.config.data.selectedCrop;
    this.session = this.config.data.session;
    this.preSelectedAssessments = this.config.data?.selectedAssessmentsList ? this.config.data?.selectedAssessmentsList : [];
    this.selTraits.push(...this.preSelectedAssessments);
    setTimeout(() => {
      const componentRef = this.viewContainerRef.createComponent(SearchGeAssessmentsHeader);
      componentRef.instance.incomingData = Object.create(this);
      let titleSpan = document.getElementsByClassName('p-dialog-header-icons')[0];
      this.renderer.appendChild(titleSpan, componentRef.location.nativeElement);
      this.search();
    },300);
  }

  addAssessments() {
    if (this.session && StaticFields.precodeScreenData?.selectedAssessmentsList) {
      const newTraits = this.selTraits.filter((st: any) => StaticFields.precodeScreenData.selectedAssessmentsList.findIndex((t: any) => t.traitId === st.traitId) === -1);
      this.ref.close({'assessmentMembers' : [...StaticFields.precodeScreenData.selectedAssessmentsList, ...newTraits]});
    }
    else
      this.ref.close({'assessmentMembers' : [...this.selTraits]});
  }

  closeDialog() {
    if (JSON.stringify(this.gridApi.getSelectedRows().map((r: any) => r.traitId)) !== JSON.stringify(this.preSelectedAssessments.map((r: any) => r.traitId))) {
      this.confirmationService.confirm({
        header : 'Confirm',
        key : "findModalExp",
        message: 'Are you sure you want to lose your changes?',
        accept: () => {
          this.ref.close();
        }
      });
    } else {
      this.ref.close();
    }
  }

  checkExistingTraits() : boolean {
    if(this.preSelectedAssessments?.length > 0 && this.gridApi?.getSelectedRows()?.length > 0) {
      const existingTraitIds = this.preSelectedAssessments.map((ele: any) => ele.traitId).sort((a,b) => a-b);
      const selectedTraitIds = this.gridApi.getSelectedRows().map((ele : any) => ele.traitId).sort((a: any,b: any) => a-b);
      return JSON.stringify(existingTraitIds) === JSON.stringify(selectedTraitIds);
    } else {
      return false;
    }
  }

  setSearch(event : any) {
    if(this.idList.length > 0 && event.value) {
      this.idList = [];
      this.rowData = [];
    }
  }

  onRowSelected(event :RowSelectedEvent) {
    if (!event.source.startsWith("api")) {
      if (event.source === "uiSelectAllFiltered") {
        const rowCnt = event.api.getSelectedRows().length;
        if (rowCnt === 0) {
          if (this.selTraits.length > 0)
            this.selTraits.splice(0);
        } else  {
          if (this.selTraits.length < rowCnt)
            this.selTraits = [...this.rowData];
        }
      } else {
        const idx = this.selTraits.findIndex((t: any) => t.traitId === event.data.traitId);
        if (idx > -1)
          this.selTraits.splice(idx, 1);
        else
          this.selTraits.push(event.data);
      }
    }
  }

  reset() {
    this.searchType =  "Get All Assessments";
    this.searchBy = "By Name";
    this.selectType = "Show all Assessments";
    this.onlyActiveTraits = true;
    this.showSelected = false;
    this.selTraits.splice(0);
    this.rowData.splice(0);
    this.idList.splice(0);
    this.preSelectedAssessments = this.config.data?.selectedAssessmentsList ? this.config.data?.selectedAssessmentsList : [];
    this.selTraits = [...this.preSelectedAssessments];
    this.setSearchType();
  }

  setSearchType() {
    this.rowData.splice(0);
    const data = JSON.parse(JSON.stringify(this.allGETraits));
    const dataToShow = this.onlyActiveTraits ? data.filter((d: any) => d.status.toUpperCase() === 'ACTIVE') : data;
    if (this.searchType === 'Get All Assessments' && this.allGETraits) {
      this.rowData = [...dataToShow];
      if (this.selTraits.length > 0) {
        setTimeout(() => {
          this.gridApi.forEachNode((node : any) => {
            const foundGe = this.selTraits?.find((ele: any) => ele.traitId == node.data.traitId)
            if (foundGe) {
              node.data.source = foundGe.source                 
              node.setSelected(true);
            }
          });
        }, 250);
      }
    } else if (this.idList.length > 0) {
      this.setGridDataByIdOrName(dataToShow);
    }
  }

  search() {
    if (!this.allGETraits || this.allGETraits.length === 0) {
      let params = new HttpParams();
      params = params.append('crop',this.selectedCrop.Description);
      this.apiService.getData('GetGEAssessments',params).subscribe( (result : any) => {
        if(result.length > 0) {
          const promise =  this.setInitialGridData(result);
          promise.then(() => {
            setTimeout(() => {
              this.gridApi.forEachNode((node : any) => {
                const foundGe = this.preSelectedAssessments?.find(ele => ele.traitId == node.data.traitId)
                if (foundGe) {
                  node.data.source = foundGe.source                 
                  node.setSelected(true);
                }
              })
            },250)
          })
        } else {
          this.customMessageService.showMessage({severity: 'warn', summary:'No Data Found', detail:"Selected crop doesn't have any assessments associated"});
        }
      });
    } else {
      const data = JSON.parse(JSON.stringify(this.allGETraits));
      const dataToShow = this.onlyActiveTraits ? data.filter((d: any) => d.status.toUpperCase() === 'ACTIVE') : data;
      if (this.searchType == "Search By Id or Name") {
        this.setGridDataByIdOrName(dataToShow)
      } else{
        this.rowData = dataToShow;
      }
    }
  }

  setInitialGridData(data : any) : any{
    const promise =  new Promise((resolve) => {
      data.forEach((ele : any) => {
        const foundTrait = this.preSelectedAssessments?.find(e => e.traitId == ele.traitId)
        ele['source'] = "Precode";
      });
      this.allGETraits = JSON.parse(JSON.stringify(data));
      const dataToShow = this.onlyActiveTraits ? data.filter((d: any) => d.status.toUpperCase() === 'ACTIVE') : data;
      if (this.searchType == "Search By Id or Name") {
        this.setGridDataByIdOrName(dataToShow)
      } else {
        this.rowData = dataToShow;
      }
      resolve(true);
    })
    return promise;
  }

  setGridDataByIdOrName(data : any) {
    if (this.searchBy == "By ID") {
      const ids = this.idListText.replace( /\n/g, " " ).replace(/\r/g, "" ).replace(',', " " ).split(" ").filter(n => n);
      this.rowData = data.filter((ele : any) => ids.findIndex(id => ele.traitId.toString() === id) !== -1)
    } else {
      const names = this.idListText.replace( /\n/g, " " ).replace(/\r/g, "" ).replace(',', " " ).split(" ").filter(n => n);
      this.rowData = data.filter((ele : any) => names.findIndex(str => ele.traitName.toLowerCase().includes(str.toLowerCase())) !== -1);
    }
    if(this.rowData.length === 0) {
      this.customMessageService.showMessage({severity: 'warn', summary:'No Data Found', detail:"Selected crop doesn't have any assessments associated"});
    } else {
      setTimeout(() => {
        this.gridApi.forEachNode((node : any) => {
          const foundGe = this.selTraits?.find((ele: any) => ele.traitId == node.data.traitId)
          if (foundGe) {
            node.data.source = foundGe.source                 
            node.setSelected(true);
          }
        });
      }, 250);
    }
  }

  onGridReady($event: GridReadyEvent<any>) {
    this.gridApi = $event.api;
  }

  private validateNumber(strNumber: string): boolean {
    var regExp = new RegExp("^[0-9]*$");
    var isValid = regExp.test(strNumber);
    return isValid;
  }

  changeListView(event: any) {
    if (event.checked) {
      if (this.selectedAssessments > 0){
        let selectedNodes: any[] = [];
        this.gridApi?.forEachNodeAfterFilterAndSort((rowNode: any, index: any) => {
          if (rowNode.isSelected()){
            selectedNodes.push(rowNode.data);
          }
        })
        this.rowData = [...selectedNodes];
        setTimeout(() => {
          this.gridApi.selectAll();      
        },15)
      } else if (this.selectedAssessments == 0) {
        this.customMessageService.showMessage({severity: 'warn', summary:'Nothing to display', detail:'Select atleast one assessment to display'});
        setTimeout(() => {
          this.showSelected = false;
        },15);
      }
    } else if(event.checked == false) {
      const selIds = this.selTraits.map((t: any) => t.traitId);
      const data = JSON.parse(JSON.stringify(this.allGETraits));
      const dataToShow = this.onlyActiveTraits ? data.filter((d: any) => d.status.toUpperCase() === 'ACTIVE') : data;
      if (this.searchType == "Search By Id or Name") {
        this.setGridDataByIdOrName(dataToShow)
      } else{
        this.rowData = [...dataToShow];
      }
      if (selIds.length > 0) {
        setTimeout(() => {
          const nodesToUpdate: any = [];
          this.gridApi?.forEachNode((node: any) => { 
            if (selIds.includes(node.data.traitId))
              nodesToUpdate.push(node);
          });
          this.gridApi?.setNodesSelected({ nodes: nodesToUpdate, newValue: true });
        }, 10);
      }
    }
  }

  allowEdit(params: any) {
    return this.session && StaticFields.precodeScreenData?.selectedAssessmentsList && StaticFields.precodeScreenData.selectedAssessmentsList.findIndex((s: any) => s.traitId === params.data.traitId) > -1 ? false : true;
  }

}